import { render } from "./ThongTinMoRong.vue?vue&type=template&id=548f065a&scoped=true"
import script from "./ThongTinMoRong.vue?vue&type=script&lang=js"
export * from "./ThongTinMoRong.vue?vue&type=script&lang=js"

import "./ThongTinMoRong.vue?vue&type=style&index=0&id=548f065a&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f065a"]])

export default __exports__